'use client';

import { c as _c } from "react/compiler-runtime";
import * as Copilot from '@copilotkit/react-core/v2';
import { type ComponentProps, useCallback, useEffect } from 'react';
import { create } from 'zustand';
export type { AssistantMessage, Message } from '@copilotkit/react-core/v2';
import { CHATBOT_THREAD_KEY } from '@libs/core/constants';
export const useAgent: typeof Copilot.useAgent = (...args) => Copilot.useAgent(...args);
export const useAgentContext: typeof Copilot.useAgentContext = (...args) => Copilot.useAgentContext(...args);
export const useCopilotKit: typeof Copilot.useCopilotKit = (...args) => Copilot.useCopilotKit(...args);
export function CopilotKit(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Copilot.CopilotKit {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function CopilotChatAssistantMessage(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Copilot.CopilotChatAssistantMessage {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function CopilotChatUserMessage(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Copilot.CopilotChatUserMessage {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function CopilotChatScrollView(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Copilot.CopilotChatView.ScrollView {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export const CopilotChatView = {
  ScrollView: CopilotChatScrollView
};
interface ChatThreadStore {
  threadId?: string;
  setThreadId: (threadId: string) => void;
}
const useChatThreadStore = create<ChatThreadStore>(set => ({
  setThreadId: threadId => set({
    threadId
  })
}));
export function useChatThread() {
  const $ = _c(12);
  const {
    threadId,
    setThreadId
  } = useChatThreadStore();
  let t0;
  if ($[0] !== setThreadId) {
    t0 = nextThreadId => {
      setThreadId(nextThreadId);
      localStorage.setItem(CHATBOT_THREAD_KEY, nextThreadId);
    };
    $[0] = setThreadId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const selectThread = t0;
  let t1;
  if ($[2] !== selectThread) {
    t1 = () => {
      const newThread = crypto.randomUUID();
      selectThread(newThread);
      return newThread;
    };
    $[2] = selectThread;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const resetThread = t1;
  let t2;
  let t3;
  if ($[4] !== resetThread || $[5] !== setThreadId) {
    t2 = () => {
      if (useChatThreadStore.getState().threadId) {
        return;
      }
      const storedThreadId = localStorage.getItem(CHATBOT_THREAD_KEY);
      if (storedThreadId) {
        return setThreadId(storedThreadId);
      }
      resetThread();
    };
    t3 = [resetThread, setThreadId];
    $[4] = resetThread;
    $[5] = setThreadId;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== resetThread || $[9] !== selectThread || $[10] !== threadId) {
    t4 = {
      threadId,
      resetThread,
      selectThread
    };
    $[8] = resetThread;
    $[9] = selectThread;
    $[10] = threadId;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}